import { AbstractControl, Validators } from '@angular/forms';

/** Whether a field must be filled: drives the asterisk of its label (`form-field__label--required`). */
export function isRequired(control: AbstractControl | null): boolean {
    return control?.hasValidator(Validators.required) ?? false;
}

/** What can take the focus inside a field: a native control, or a PrimeNG control's focusable part. */
const FOCUSABLE = 'input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])';

/**
 * On submit: when the form is invalid, marks every field touched so all their errors show, and
 * moves the focus to the first invalid field inside `host`. Returns whether the form can be sent.
 */
export function revealFormErrors(form: AbstractControl, host: HTMLElement): boolean {
    if (form.valid) {
        return true;
    }
    form.markAllAsTouched();
    firstInvalidField(host)?.focus();
    return false;
}

/**
 * The first invalid field in document order. The form and its groups carry `ng-invalid` too, so
 * the field is the first invalid element that holds no other one; a PrimeNG control (`p-select`…)
 * carries the class on its host, so the focus goes to the focusable element inside it.
 */
function firstInvalidField(host: HTMLElement): HTMLElement | null {
    const field = Array.from(host.querySelectorAll<HTMLElement>('.ng-invalid')).find(
        (element) => !element.querySelector('.ng-invalid'),
    );
    if (!field) {
        return null;
    }
    return field.matches(FOCUSABLE) ? field : field.querySelector<HTMLElement>(FOCUSABLE);
}
